function buybox_setavailability(ref, index, opt1, opt2, opt3, pgi)
{	
	var opts = $("[data-product-id='"+ref+"'][data-option='"+index+"'] .opt");
	
	for (var i=0;i<opts.length;i++)
	{	
		var elm = $(opts[i]);
		
		var select_option = "";
		
		var my_value = elm.attr('data-value');
		
		switch (index)
		{	
			case 0:
				var select_option = $("#buybox-select-" + ref + " option[data-product-id='" + ref + "'][data-option-1='"+my_value+"']option[data-option-2='"+opt2+"'][data-option-3='"+opt3+"']");
			break;
			case 1:
				var select_option = $("#buybox-select-" + ref + " option[data-product-id='" + ref + "'][data-option-1='"+opt1+"']option[data-option-2='"+my_value+"'][data-option-3='"+opt3+"']");
			break;
			case 2:
				var select_option = $("#buybox-select-" + ref + " option[data-product-id='" + ref + "'][data-option-1='"+opt1+"']option[data-option-2='"+opt2+"'][data-option-3='"+my_value+"']");
			break;
			case "pgi":
				var select_option = $("#buybox-select-" + ref + " option[data-product-id='" + elm.attr("data-product-id") + "'][data-option-1='"+opt1+"']option[data-option-2='"+opt2+"'][data-option-3='"+opt3+"']");
			break;
		}
		
		if (select_option.length > 0)
		{	
			if (select_option.attr("data-available")=="true")
			{	
				elm.addClass("available");
				elm.removeClass("unavailable");
			} else
			{	
				elm.addClass("unavailable").removeClass("available").removeClass("off");
			}
		} else
		{	
			elm.addClass("available").removeClass("unavailable");
		}
	}
}

function buybox_option_initialise(ref, opt, el)
{	
	var opt1 = $("[data-product-id='"+ref+"'][data-option='0'] .opt.on").attr('data-value');
	var opt2 = $("[data-product-id='"+ref+"'][data-option='1'] .opt.on").attr('data-value');
	var opt3 = $("[data-product-id='"+ref+"'][data-option='2'] .opt.on").attr('data-value');
	var pgi = $("[data-product-id='"+ref+"'][data-option='pgi'] .opt.on").attr('data-value');
	
	if (typeof opt1 == 'undefined') { opt1 = ""; }
	if (typeof opt2 == 'undefined') { opt2 = ""; }
	if (typeof opt3 == 'undefined') { opt3 = ""; }
	if (typeof pgi == 'undefined') { pgi = ""; }
	
	$("#buybox-select-" + ref + " option").each(
		function(i) {
			if (
				$(this).attr("data-product-id") == ref && 
				$(this).attr("data-option-1") == opt1 && 
				$(this).attr("data-option-2") == opt2 && 
				$(this).attr("data-option-3") == opt3
			)
			{	
				$("#buybox-select-" + ref).val($(this).attr("value"));
				
				if ($(this).attr("data-price-original") == "")
				{	
					$("#buybox-price-" + ref).html($(this).attr("data-price").replace(".00", ""));
				} else
				{	
					$("#buybox-price-" + ref).html($(this).attr("data-price").replace(".00", "") + " <span class='strikethru'>" + $(this).attr("data-price-original").replace(".00", "") + "</span>");
				}
				
				if ($(this).attr("data-available")=="true")
				{	
					$("#buybox-cta-" + ref).removeAttr('disabled');
					$("#buybox-cta-" + ref).text("Buy Now");
					$("#buybox-cta-" + ref).removeClass("primary-button").removeClass("secondary-button").addClass("primary-button");
					$("#buybox-quantity-" + ref).show();
				} else
				{	
					if ($(this).attr("data-notifications")=="true")
					{	
						$("#buybox-cta-" + ref).removeAttr('disabled');
						$("#buybox-cta-" + ref).html("Notify Me \u00BB");
						$("#buybox-cta-" + ref).removeClass("primary-button").removeClass("secondary-button").addClass("secondary-button");
						$("#buybox-quantity-" + ref).hide();
					} else
					{	
						$("#buybox-cta-" + ref).attr('disabled','disabled');
						$("#buybox-cta-" + ref).text("Sold Out");
						$("#buybox-cta-" + ref).removeClass("primary-button").removeClass("secondary-button").addClass("secondary-button");
						$("#buybox-quantity-" + ref).hide();
					}
				}
			}
			
		}
	);
	
	buybox_setavailability(ref, "pgi", opt1, opt2, opt3, pgi);
	
	switch (opt)
	{	
		case 0:
			buybox_setavailability(ref, 1, opt1, opt2, opt3, pgi);
			buybox_setavailability(ref, 2, opt1, opt2, opt3, pgi);
		break;
		
		case 1:
			buybox_setavailability(ref, 0, opt1, opt2, opt3, pgi);
			buybox_setavailability(ref, 2, opt1, opt2, opt3, pgi);
		break;
		
		case 2:
			buybox_setavailability(ref, 0, opt1, opt2, opt3, pgi);
			buybox_setavailability(ref, 1, opt1, opt2, opt3, pgi);
		break;
	}
}

function buybox_option_select(ref, opt, el)
{	
	var el = $(el);
	
	//if (el.hasClass("available"))
	{	
		$("[data-product-id='"+ref+"'][data-option='"+opt+"'] button.opt").removeClass("on").addClass("off");
		el.addClass("on").removeClass("off");
		
		buybox_option_initialise(ref, opt, el);
		track_viewed_variant();
		buybox_setvariants(ref);
	}
	
	return false;
}

function buybox_groupproductitem_select(ref, elm)
{	
	var elm = $(elm);
	
//	if (elm.hasClass("available"))
	{	
		if (elm.attr("href"))
		{	
			var new_product_id = elm.attr("data-product-id");
			
			var selected = $('#buybox-select-' + ref).find(":selected");
			
			var match = $('#buybox-select-' + ref).find("[data-product-id='" + new_product_id + "'][data-available='true'][data-option-1='" + selected.attr("data-option-1") + "'][data-option-2='" + selected.attr("data-option-2") + "'][data-option-3='" + selected.attr("data-option-3") + "']");
			
			if (match.length > 0)
			{	
				var new_url = elm.attr('href') + '?variant=' + $(match[0]).attr("value");
				
				$("main#content").load(new_url + " main#content > *", function()
				{	
					history.replaceState({}, "", new_url);
					buybox_initialise(new_product_id);
					slider_init();
					reviewsio_setup();
					drawer_links();
					init_timers();
					
					track_viewed_variant();
				});
				
				return false;
			} else
			{	
				return true;
			}
		} else
		{
			return false;
		}
	}// else
//	{	
//		return false;
//	}
}


function buybox_setvariants(ref)
{	
	var variant_id = $("#buybox-select-" + ref).val();
	
	if (variant_id != "")
	{	
		$(".complementary-variant").removeClass("complementary-variant-enabled");
		$(".complementary-variant-checkbox").prop("checked", false);
		
		var dta = $("#buybox-select-" + ref + " [data-product-id='"+ref+"'][value="+$("#buybox-select-" + ref).val()+"]")
		
		if (dta)
		{	
			if (dta.attr("data-available")=="true")
			{	
				$("[data-variant-id='"+variant_id+"'].complementary-variant").addClass("complementary-variant-enabled");
			} else
			{	
				
			}
		} else
		{	
			$("[data-variant-id='"+variant_id+"'].complementary-variant").addClass("complementary-variant-enabled");
		}
	}
}


function buybox_initialise(ref)
{	
	$("div.buybox select.product-select").hide();
	
	buybox_option_initialise(ref, 0, false);
	buybox_option_initialise(ref, 1, false);
	buybox_option_initialise(ref, 2, false);
	
	$(".opt-groupproduct:not([data-enabled='1'])").on("click", function () {
		return buybox_groupproductitem_select(ref, this);
	});
	
	$(".opt-groupproduct").attr("data-enabled", "1");
}



function load_cart(callback)
{	
	$.ajax(window.Shopify.routes.root + 'cart.js', {
			type : 'GET',
			async: false,
			success: function(a,b,c) {
				var a = JSON.parse(a);
				console.log(a);
				callback(a);
				load_cart_complete(a);
			}
		}
	);
	
}


function load_cart_complete(basket)
{	
	
}


function add_to_cart_success_reload_basket(basket)
{	
	if (basket.total_price)
	{	
		$(".drawer-basket .basket-total-price").html("<div>Basket Total &pound;" + Math.round(basket.total_price / 100).toFixed(2).replace(".00", "") + "</div>");
		
		_paq.push(['trackEcommerceCartUpdate', Math.round(basket.total_price / 100).toFixed(2)]); 
		
	}
}


function add_to_cart_success(json, status, obj, items)
{	
	var res = JSON.parse(json);
	
	if (items.items)
	{	
		var html = "<p>Item was successfully added to your basket.</p>";
		var title = "Item Added";
		if (items.items.length > 1)
		{	
			html = "<p>Items were successfully added to your basket.</p>";
			title = "Items Added";
		}
		
		var variant_ids = [];
		
		var html_items = "";
		console.log(res.items);
		for (var i=0; i < res.items.length; i++)
		{	
			var item = res.items[i];
			
			variant_ids.push(parseInt(item.variant_id));
			
			var item_added = false;
			for (var n=0;n<items.items.length;n++)
			{	
				if (items.items[n].id == item.id)
				{	
					item_added = items.items[n];
				}
			}
			
			if (item_added != false)
			{	
				// trk
				
				_paq.push(['addEcommerceItem',
					item.sku,
					item.title,
					[item.product_type],
					Math.round(item.final_price / 100).toFixed(2),
					item.quantity
				]);
				
				_paq.push(['trackEvent', 'Basket', 'Added', item.quantity + "x " + item.sku]);
				
				gtag("event", "add_to_cart", {
					currency: "GBP",
					value: Math.round((item.final_price / 100) * item_added.quantity).toFixed(2),
					items: [
						{
							item_id: item.sku,
							item_name: item.title,
							price: Math.round(item.final_price / 100).toFixed(2),
							quantity: item_added.quantity,
							item_brand: item.vendor,
							item_variant: item.variant_title
						}
					]
				});
				
				html_items+= '<div class="basket-item">';
				html_items+= '<div class="basket-item-image"><img src="' + item.image + '"></div>';
				
				html_items+= '<div class="basket-item-info">';
				html_items+= '<strong>' + item_added.quantity + 'x ' + item.product_title + '</strong><br>';
				if (item.product_has_only_default_variant == false)
				{	
					var options = [];
					for (var x=0; x < item.options_with_values.length; x++)
					{	
						options.push(item.options_with_values[x].name + ": " + item.options_with_values[x].value);
					}
					
					html_items+= options.join(", ") + "<br>";
				}
				html_items+= '<span class="basket-item-price">&pound;' + Math.round(item.final_price / 100).toFixed(2).replace(".00", "") + '</span>';
				html_items+= '</div>';
				
				html_items+= '</div>';
			}
		}
		
		if (html_items!="")
		{	
			html+= '<div class="basket-item-list">' + html_items + '</div>';
		}
		
		html+= "<div class='basket-total-price'></div>";
		
		html+= "<div class='buttons'><a href='/checkout' class='button primary-button'>Checkout</a><a href='/cart' class='button'>Edit Basket</a></div>";
		html+= "<p class='a' onclick='drawer_close();'>Continue shopping...</p>";
		
		var bought_together_html = "";
		for (var i=0;i<items.items.length;i++)
		{	
			var variant_id = items.items[i].id;
			
			var also_try = $("[data-variant-id='"+variant_id+"'].complementary-variant");
			
			for (var j=0;j<also_try.length;j++)
			{	
				var variant = $(also_try[j]);
				
				if (variant_ids.includes(parseInt(variant.attr("data-complementary-variant-id"))) == false)
				{	
					bought_together_html+= "<a class='bought-together' href='" + variant.attr("data-url") + "'>"
					bought_together_html+= "<img src='" + variant.attr("data-image") + "'>";
					bought_together_html+= "<span>" + variant.attr("data-title") + "<br>" + variant.attr("data-price") + "</span>";
					bought_together_html+= "</a>";
				}
			}
		}
		
		if (bought_together_html != "")
		{	
			html+= "<div class='bought-together'>";
			html+= "<h3>Customers Also Buy</h3>";
			html+= bought_together_html;
			html+= "</div>";
		}
	}
	
	
	html = "<div class='drawer-basket'>" + html + "</div>";
	
	drawer_open(html, title);
	
	load_cart(add_to_cart_success_reload_basket);
}


function draw_notify_do(uid, ref)
{	
//	const emailPattern = /^(?!.*\.\.)(?!.*\.$)(?!.*@.*@)(?!.*@.*\.)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
	const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
	
	var email = $("#notify_" + ref).val();
	
	if (!emailPattern.test(email))
	{	
		alert("Check your email address is correct and try again!");
	} else
	{	
		var json = {
			"data":{
				"type":"back-in-stock-subscription",
				"attributes":{
					"profile":{
						"data":{
							"type":"profile",
							"attributes":{
								"email":email
							}
						}
					},
					"channels":["EMAIL"]
				},
				"relationships":{
					"variant":{
						"data":{
							"type":"catalog-variant",
							"id":"$shopify:::$default:::" + uid
						}
					}
				}
			}
		};
		
		
		var options = {
			method: 'POST',
			headers: {
				accept: 'application/vnd.api+json',
				revision: '2024-10-15',
				'content-type': 'application/vnd.api+json'
			},
			body: JSON.stringify(json)
		};
		
		fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=Xav2fa', options)
			.then(
				function (e) {
					if (e.status == 200 || e.status == 202 || e.status == 204)
					{	
						var html = "";
						
						html+= "<p>Thank you for submitting your email address, we will keep you posted.</p>";
						html+= "<p><a class='a' href='#' onclick='drawer_close(); return false;'>Continue shopping...</a></p>";
						
						$("#NotifySubscribe").html(html);
					} else
					{	
						alert("Could not sign you up, try checking your email address is correct, or contact customer services!");
					}
				}
			)
			.catch(
				function (e) {
					alert("Could not sign you up, try checking your email address is correct, or contact customer services!");
				}
			)
		;
	}
}


function drawer_notify(dta, ref)
{	
	var product = $("section[data-id=" + ref + "]");
	
	var title = "Out of Stock!";
	var html = "";
	
	html+= "<p>This product is currently out of stock. Submit your email address here to be notified as soon as it comes back.</p>";
	
	var sub_html = [];
	{	
		if (dta.attr("data-option-1")!="") { sub_html.push(dta.attr("data-option-1")); }
		if (dta.attr("data-option-2")!="") { sub_html.push(dta.attr("data-option-2")); }
		if (dta.attr("data-option-3")!="") { sub_html.push(dta.attr("data-option-3")); }
	}
	
	if (product)
	{	
		if (product.attr("data-group")!="")
		{	
			html+= "<p><strong>Item:</strong> " + product.attr("data-group");
			html+= "<br><strong>Option:</strong> " + product.attr("data-name-short") + " / " + sub_html.join(" / ") + "</p>";
		} else
		{	
			html+= "<p><strong>Item:</strong> " + product.attr("data-name-short") + " / " + sub_html.join(" / ") + "</p>";
		}
	} else
	{	
		html+= "<p><strong>Item:</strong> " + sub_html.join(" / ") + "</p>";
	}
	
	html+= "<div id='NotifySubscribeForm'>";
	
	html+= "<input type='email' id='notify_"+ref+"' value='' placeholder='Your email address'><br>";
	
	html+= "<button type='button' class='button primary-button' onclick='return draw_notify_do(" + dta.attr("value") + ", " + ref + ");'>Keep me posted</button>";
	
	html+= "</div>";
	
	html = "<div id='NotifySubscribe'>" + html + "</div>";
	
	drawer_open(html, title);
}


function buybox_button_click(e, ref)
{	
	var elm = $("select#buybox-select-"+ref+" [data-product-id='"+ref+"'][value="+$("#buybox-select-" + ref).val()+"]");
	
	if (elm.attr("data-available")=="true" || elm.attr("data-available")=="")
	{	
		return add_to_cart(ref);
	} else
	{	
		e.preventDefault();
		
		if (elm.attr("data-notifications")=="true")
		{	
			drawer_notify(elm, ref);
		}
		
		return false;
	}
}


function add_to_cart(ref)
{	
	var items = {
		"items": [
			{"id": $("#buybox-select-" + ref).val(), "quantity": $("#buybox-quantity-" + ref).val()}
		]
	};
	
	var bundled = $(".complementary-variant-enabled .complementary-variant-checkbox:checked");
	
	for (var i =0; i < bundled.length; i++)
	{	
		items["items"].push({
			"id": $(bundled[i]).attr("data-variant-id"),
			"quantity": 1
		});
	}
	
	$.ajax(window.Shopify.routes.root + 'cart/add.js', {
			data : JSON.stringify(items),
			contentType : 'application/json',
			type : 'POST',
			async: false,
			success: function(a,b,c) { add_to_cart_success(a,b,c,items); }
		}
	);
	
	return false;
}


function do_subscribe()
{	
	if (window._klOnsite)
	{	
		var r =window._klOnsite.push(['openForm', 'SsG8KR']);
		console.log(r);
		
		if (typeof r !== "undefined" && r > 0)
		{	
			console.log("not empty");
			return true;
		} else
		{	
			return false;
		}
	} else
	{	
		console.log("not loaded");
		return true;
	}
}


function init_timers()
{	
	$('.timer').each(function () {
		if ($(this).attr('data-loaded') != "true")
		{	
			const $this = $(this);
			const targetDate = new Date($this.attr('data-countdown'));
			const wording = $this.attr('data-wording') || "";
			const design = $this.attr('data-design') || "standard";
			let showDot = true;
			
			$this.parent().addClass("timer-container");
			
			function updateCountdown() {
				$this.attr('data-loaded', 'true');
				
				const now = new Date();
				const difference = targetDate - now;
				if (difference <= 0) {
					$this.css("display", "none");
					return;
				}
				
				const days = Math.floor(difference / (1000 * 60 * 60 * 24));
				const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((difference % (1000 * 60)) / 1000);
				
				let displayText = '';
				
				switch (design)
				{	
					case "smart":
						if (days > 30) {
							displayText = `${days} days`;
						} else if (days > 1) {
							displayText = `${days}d ${hours}h`;
						} else if (days === 1) {
							displayText = `1 day ${hours}h`;
						} else if (hours >= 1) {
							displayText = `${hours}h ${minutes}m`;
						} else if (minutes >= 1) {
							displayText = `${minutes}m ${seconds}s`;
						} else {
							displayText = `${seconds}s`;
						}
						if (wording != "")
						{	
							displayText = displayText + " " + wording;
						}
						
						displayText += showDot ? '.' : '&nbsp;';
						showDot = !showDot;
					break;
					
					default:
						displayText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
						
						if (wording != "")
						{	
							displayText = displayText + " " + wording;
						}
					break;
				}
				
				if (displayText != "")
				{	
					$this.html(displayText);
					$this.css("display", "inline-flex");
				}
			}
			
			updateCountdown();
			setInterval(updateCountdown, 1000);
		}
	});
	
}


$(document).ready(function () {
	init_timers();
});
